import * as React from 'react';
export const awss3Svg = React.forwardRef(function awss3SvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_awss3__a)',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'm24.334 17.157.154-1.082c1.416.849 1.435 1.2 1.434 1.209-.002.002-.244.203-1.588-.127Zm-.777-.216c-2.448-.74-5.857-2.305-7.237-2.957l.002-.016a.962.962 0 0 0-1.922 0c0 .53.43.961.96.961a.955.955 0 0 0 .611-.225c1.623.769 5.006 2.31 7.472 3.038l-.975 6.882a.382.382 0 0 0-.004.057c0 .606-2.683 1.719-7.066 1.719-4.43 0-7.142-1.113-7.142-1.72a.41.41 0 0 0-.003-.054L6.215 9.743C7.98 10.957 11.772 11.6 15.4 11.6c3.622 0 7.41-.64 9.176-1.85l-1.019 7.191ZM6 8.191C6.029 7.665 9.054 5.6 15.4 5.6s9.37 2.064 9.4 2.591v.18c-.348 1.18-4.268 2.429-9.4 2.429-5.14 0-9.063-1.253-9.4-2.435v-.174Zm19.6.009c0-1.386-3.974-3.4-10.2-3.4-6.226 0-10.2 2.014-10.2 3.4l.038.301 2.219 16.21c.053 1.813 4.887 2.489 7.94 2.489 3.79 0 7.815-.871 7.867-2.488l.958-6.759c.533.128.972.193 1.324.193.474 0 .794-.115.988-.347a.78.78 0 0 0 .174-.663c-.104-.554-.76-1.15-2.1-1.914l.951-6.705.041-.317Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_awss3__a',
          x1: 16,
          x2: 48,
          y1: 48,
          y2: 16,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#1B660F',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#6CAE3E',
        }),
      ),
    ),
  );
});
awss3Svg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var awss3 = {
  category: 'brand',
  colorable: false,
  name: 'awss3',
  svg: awss3Svg,
};
